<mat-divider></mat-divider>

<div class="ep-card-footer">
  <ng-content></ng-content>
</div>
